import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../modules/auth';
import { ValidTokenResponse } from '../modules/auth/components/models/auth.token.valid.response.model';


@Injectable({
    providedIn: 'root'
})
export class ValidTokenGuard implements CanActivate {


    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        const wrapperSubject = new Subject<boolean>();
        this.authService.isValidToken().subscribe((res : ValidTokenResponse) => {
            if(res?.isValid) return wrapperSubject.next(true);
            this.authService.clearCookiesAndLocalStorage();
            return wrapperSubject.next(false);
        }, (err : any)=> {
            this.authService.clearCookiesAndLocalStorage();
            return wrapperSubject.next(false);
        });
        return wrapperSubject;
    }

}
